import qs from 'qs';
import { wixSdkAdapter } from './wixSdkAdapter';

export const isInModal = (): boolean => {
  // introduced in v230, https://jira.wixpress.com/browse/PLAT-136
  if (
    wixSdkAdapter.isAvailable() &&
    wixSdkAdapter.Wix.Utils.hasOwnProperty('isInModal')
  ) {
    return wixSdkAdapter.Wix.Utils.isInModal();
  }

  const query = qs.parse(document.location.search.slice(1));
  return !!query && query.isInModal === 'true';
};
